import { ChangeDetectionStrategy, Component, computed, input, OnInit, signal } from '@angular/core';
import { KpiReportService } from 'src/app/api/kpiReport.service';
import { DonorCareData, PartnerCommunicationData, StaffKpiData } from 'src/app/api/types/kpi';
import { StaffDisplayPipe } from 'src/app/ui/pipes/staff-display.pipe';
import { KpiReportScoreRangePipe } from '../kpi-report-score-range.pipe';
import { ConfigService } from 'src/app/config.service';
import { DateTime } from 'luxon';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconService } from 'src/app/ui/icon.service';


interface KpiDisplayData extends StaffKpiData {
  partnerCareReportUrl: string,
  donorCareReportUrl: string
}

@Component({
  selector: 'app-individual-staff-kpi-report',
  imports: [KpiReportScoreRangePipe, FontAwesomeModule],
  templateUrl: './individual-staff-kpi-report.component.html',
  styleUrl: './individual-staff-kpi-report.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndividualStaffKpiReportComponent implements OnInit {


  inputKpiData = input.required<StaffKpiData | number>()
  yerMode = input<boolean>(false)

  kpiData = signal<KpiDisplayData>(this.kpiReportService.emptyStaffKpiData() as unknown as KpiDisplayData)

  sortedKpiData = computed(() => {
    // First sort by report order
    const sortedData = this.kpiData().kpis.sort((a, b) => {
      return a.reportOrder - b.reportOrder
    })

    // Get distinct areas in order they first appear
    const areaOrder = [...new Set(sortedData.map(k => k.area))]

    // Sort again by area order while preserving report order within areas
    return sortedData.sort((a, b) => {
      const areaIndexA = areaOrder.indexOf(a.area)
      const areaIndexB = areaOrder.indexOf(b.area)
      if (areaIndexA !== areaIndexB) {
        return areaIndexA - areaIndexB
      }
      return a.reportOrder - b.reportOrder
    })



  })

  

  areaRowCount = computed(() => {
    return this.kpiData().kpis.reduce((acc, kpi) => {
      acc.set(kpi.area, (acc.get(kpi.area) || 0) + 1)
      return acc
    }, new Map<string, number>())
  })

  constructor(
    private kpiReportService: KpiReportService,
    private config: ConfigService,
    public icons: IconService
  ) {

    const nowCentral = DateTime.now().setZone('America/Chicago')
    const currentQuarter = nowCentral.quarter


  }


  ngOnInit() {

    const inputData = this.inputKpiData()

    if (typeof inputData == 'number') {
      this.kpiReportService.getKpiReportForStaff(inputData, this.yerMode()).subscribe(data => {
        this.kpiData.set(this.processKpiData(data))
      })
    }
    else {
      this.kpiData.set(this.processKpiData(inputData))
    }
  }

  processKpiData(data: StaffKpiData) {
    const partnerCommunicationKpi = data.kpis.find(kpi => kpi?.data?.kpiType === 'locationPartnerCommunication')?.data as PartnerCommunicationData
    const donorCareKpi = data.kpis.find(kpi => kpi?.data?.kpiType === 'locationDonorCare')?.data as DonorCareData

    let partnerCareReportUrl = ''
    let donorCareReportUrl = ''

    if (partnerCommunicationKpi ) {
      const endDate = DateTime.fromISO(partnerCommunicationKpi.endDate)
      const startDate = endDate.startOf('year')
      partnerCareReportUrl = `${this.config.baseUrl}/consulting/partner-care-report?startDate=${startDate.toFormat('yyyy-MM-dd')}&endDate=${endDate.toFormat('yyyy-MM-dd')}${partnerCommunicationKpi.locationIds.map(id => `&locationIds=${id}`).join('')}`
    }

    if (donorCareKpi) {
      const endDate = DateTime.fromISO(donorCareKpi.endDate)
      const startDate = endDate.startOf('year')
      donorCareReportUrl = `${this.config.baseUrl}/ppm365/donor-care-report?startDate=${startDate.toFormat('yyyy-MM-dd')}&endDate=${endDate.toFormat('yyyy-MM-dd')}${donorCareKpi.locationIds.map(id => `&locationIds=${id}`).join('')}`
    }



    return {
      ...data,
      partnerCareReportUrl: partnerCareReportUrl,
      donorCareReportUrl: donorCareReportUrl
    }
  }

}
